import React, { useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CalendarMonth from "./CalendarMonth";
dayjs.extend(customParseFormat);

const MakeBooking = ({ slotsFromParent, setSlotsFromParent, slotsData, fetchAndGroupSlots }) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [slots, setSlots] = useState([]);
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [age, setAge] = useState("");
    const [communicationMode, setCommunicationMode] = useState("hindi");
    const [classPurpose, setClassPurpose] = useState("Sun salutation- physical work");
    const [userType, setUserType] = useState("First timer");
    const [loading, setLoading] = useState(false); // Loader state

    const currentDate = dayjs();
    const nextMonthDate = currentDate.add(1, "month");

    const generateMonthDays = (monthStartDate) => {
        const daysInMonth = monthStartDate.daysInMonth();
        return Array.from({ length: daysInMonth }, (_, i) =>
            monthStartDate.date(i + 1)
        );
    };

    const daysArrayCurrent = generateMonthDays(currentDate.startOf("month"));
    const daysArrayNext = generateMonthDays(nextMonthDate.startOf("month"));
    const daysArray = [...daysArrayCurrent, ...daysArrayNext];

    console.log(slotsData);

    // Extract available slot dates
    const availableDates = slotsData
        .filter((slot) => slot?.slots?.length > 0 && slot.slots.some(s => s.isSlotFilled === false)) // Keep dates with at least one unfilled slot
        .map((slot) => slot.date);



    // Handle date click
    const handleDateClick = (date) => {
        const formattedDate = date.format("DD-MM-YYYY");

        // If the clicked date is the already selected date, do nothing
        if (formattedDate === selectedDate) return;

        setSelectedDate(formattedDate);
        const slotInfo = slotsData.find((slot) => slot.date === formattedDate);
        setSlots(slotInfo ? slotInfo.slots : []);
    };


    const handleBookClick = (slot) => {
        setSelectedSlot(slot);
        setShowDialog(true);
    };

    const handleSubmitBooking = async () => {
        if (!email) return alert("Please enter an email!");
        if (!name) return alert("Please enter your name!");

        const scriptUrl = "https://script.google.com/macros/s/AKfycbwIGNAgvffPjm73ncz0HQNYQEYPkIJSppBAbxMf2eaDrFei6FefpjYiAAmKBwjyjsMN/exec";

        setLoading(true); // Show loader when booking request is in progress
        setShowDialog(false);

        const response = await fetch(scriptUrl, {
            redirect: "follow",
            method: "POST",
            mode: "cors",
            headers: { "Content-Type": "text/plain;charset=utf-8" },
            body: JSON.stringify({
                date: selectedDate,
                slotId: selectedSlot.slotId,
                email: email,
                name: name,
                age: age,
                communicationMode: communicationMode,
                classPurpose: classPurpose,
                userType: userType
            }),
        });

        const result = await response.json();

        setLoading(false); // Hide loader once the response is received

        if (result.success) {
            alert("Booking confirmed!");
            setEmail("");
            setName("");
            setAge("");

            // Refetch updated slots
            const slotResults = await fetchAndGroupSlots();
            setSlotsFromParent(slotResults);
            window.location.reload();
        } else {
            alert("Slot not found or already booked.");
        }
    };



    return (
        <div className="calendar-container">
            {/* Loader */}
            {loading && (
                <div className="loader">
                    <div className="spinner"></div>
                    <div className="loading-text">Booking in progress...</div>
                </div>
            )}
            <h2 className="calendar-title">
                {currentDate.format("MMMM YYYY")} & {nextMonthDate.format("MMMM YYYY")}
            </h2>

            {/* Calendar Grid */}
            {/* <div className="calendar-grid">
                {(() => {
                    const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                    return (
                        <>
                            {weekdayNames.map((weekday) => (
                                <div key={weekday} className="calendar-weekday">
                                    {weekday}
                                </div>
                            ))}
                        </>
                    );
                })()}

                {Array.from({ length: daysArray[0].day() }, (_, i) => (
                    <div key="empty{i}" className="calendar-day">
                    </div>
                ))}

                {daysArray.map((day) => {
                    const formattedDate = day.format("DD-MM-YYYY");
                    const hasSlots = availableDates.includes(formattedDate);
                    const isSelected = formattedDate === selectedDate; // Check if the date is selected

                    const isPast = day.isBefore(dayjs(), "day"); // Compare only date, ignore time

                    return (
                        <div
                            key={formattedDate}
                            className={`calendar-day ${hasSlots ? "available" : ""} ${isSelected ? "selected" : ""}  ${isPast ? "past" : ""}`} // Add "selected" class if the date is selected
                            onClick={!isPast ? () => handleDateClick(day) : undefined}
                        >
                            {day.date()}
                        </div>
                    );
                })}
            </div> */}

            <div className="calendar-months-wrapper">
                <CalendarMonth
                    daysArray={daysArrayCurrent}
                    title={currentDate.format("MMMM YYYY")}
                    availableDates={availableDates}
                    selectedDate={selectedDate}
                    handleDateClick={handleDateClick}
                />
                <CalendarMonth
                    daysArray={daysArrayNext}
                    title={nextMonthDate.format("MMMM YYYY")}
                    availableDates={availableDates}
                    selectedDate={selectedDate}
                    handleDateClick={handleDateClick}
                />
            </div>


            {/* Slot Details */}
            {selectedDate && (
                <div className="slot-container">
                    <h3 className="slot-title">Slots for {dayjs(selectedDate, "DD-MM-YYYY").format("DD MMM YYYY")}</h3>
                    {slots.length > 0 ? (
                        slots.map((slot) => !slot.isSlotFilled && (
                            <div key={slot.slotId} className="slot-card">
                                <p><strong>Time:</strong> {slot.startTime} - {slot.endTime} <b>EDT</b> </p>
                                <p><strong>Group Slot:</strong> {slot.isGroupSlot ? "Yes" : "No"}</p>
                                {/* <p><strong>Available Spots:</strong> {slot.accommodationCount}</p> */}
                                {/* <p><strong>Focus area:</strong> {slot.focusArea}</p> */}
                                <button className="book-button" onClick={() => handleBookClick(slot)}>Book</button>
                            </div>
                        ))
                    ) : (
                        <p>No slots available.</p>
                    )}
                </div>
            )}

            {/* Booking Dialog */}
            {showDialog && (
                <div className="dialog-container">
                    <div className="dialog">
                        <h3>Enter Your Details</h3>
                        <input
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Enter name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <input type="number" placeholder="Age" value={age} onChange={(e) => setAge(e.target.value)} />
                        <div className="radio-group">
                            <h4>Mode of Communication:</h4>
                            <label><input type="radio" value="hindi" checked={communicationMode === "hindi"} onChange={() => setCommunicationMode("hindi")} /> Hindi</label>
                            <label><input type="radio" value="english" checked={communicationMode === "english"} onChange={() => setCommunicationMode("english")} /> English</label>
                        </div>
                        <div className="radio-group">
                            <h4>Purpose of Class:</h4>
                            {["Sun salutation- physical work", "Healing / Restorative", "Breathwork", "Mental relaxation", "Yoga nidra", "Subtle rejuvenating movements"].map((purpose) => (
                                <label key={purpose}><input type="radio" value={purpose} checked={classPurpose === purpose} onChange={() => setClassPurpose(purpose)} /> {purpose}</label>
                            ))}
                        </div>
                        <div className="radio-group">
                            <h4>User Type:</h4>
                            <label><input type="radio" value="First timer" checked={userType === "First timer"} onChange={() => setUserType("First timer")} /> First timer</label>
                            <label><input type="radio" value="Repeater" checked={userType === "Repeater"} onChange={() => setUserType("Repeater")} /> Repeater</label>
                        </div>
                        <button onClick={handleSubmitBooking}>Submit</button>
                        <button onClick={() => setShowDialog(false)}>Cancel</button>
                    </div>
                </div>
            )}
        </div>
    );
};


export default MakeBooking;
